module.exports = __webpack_public_path__ + "static/img/hand2.b39b675.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hand2.png
// module id = A2QP
// module chunks = 208